import React from "react";

const LiveChat = ({ src }) => {
  return <iframe src={src} frameBorder="0"></iframe>;
};

export default LiveChat;
